import * as React from 'react';
import { Link } from 'react-router-dom';
import { MdEqualizer as MdCharts, MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { routeConstants } from 'app/routes/route-constants';
import { When } from './when';
import { hasDashboardOrReportAdministrationAccess } from './menu-access-guards';
import { MenuAccess } from '../../../types';
import styles from '../mobile-nav.scss';

interface Props {
  translation: any;
  menuAccess: MenuAccess;
  onItemClick: () => void;
}

export const ToolsDashboardsReportsMenuItem = ({ translation, menuAccess, onItemClick }: Props) => (
  <When condition={hasDashboardOrReportAdministrationAccess(menuAccess)}>
    <li>
      <input type="checkbox" id="mobile-admin-dashboards-reports" />

      <div className={`${styles.dropdownButton} list-group-item`}>
        <MdCharts className={styles.navItemIcon} />
        <span className={`${styles.navItemText} ${styles.small}`}>
          {translation.dashboards_and_reports}
        </span>
        <label className={styles.dropdownLabel} htmlFor="mobile-admin-dashboards-reports">
          <MdKeyboardArrowDown className={styles.down} />
          <MdKeyboardArrowUp className={styles.up} />
        </label>
      </div>

      <ul className={styles.subMenu}>
        <When condition={menuAccess.dashboardAdministration}>
          <li className={styles.child} onClick={onItemClick}>
            <Link to={routeConstants.dashboardAdminList} className="list-group-item">
              <span className={styles.navItemText}>
                {translation.manage_dashboard}
              </span>
            </Link>
          </li>
        </When>
        <When condition={menuAccess.companyReportAdministration}>
          <li className={styles.child} onClick={onItemClick}>
            <Link to={routeConstants.companyReportAdminList} className="list-group-item">
              <span className={styles.navItemText}>
                {translation.reports_company}
              </span>
            </Link>
          </li>
        </When>
        <When condition={menuAccess.favouriteAdministration}>
          <li className={styles.child} onClick={onItemClick}>
            <Link to={routeConstants.favouriteAdminList} className="list-group-item" >
              <span className={styles.navItemText}>
                {translation.manage_favourites}
              </span>
            </Link>
          </li>
        </When>
      </ul>
    </li>
  </When>
);
